import { useEffect, useState } from "react";
import useDebounce from "utilities/hooks/use-debounce";

export interface UseAutoSaveOptions<T> {
    delayInSeconds: number;
    onSave: () => Promise<void>;
    value: T;
}

const useAutoSave = <T>({
    onSave,
    delayInSeconds,
    value,
}: UseAutoSaveOptions<T>) => {
    const debouncedValue = useDebounce(value, delayInSeconds * 1000);
    const [isSaved, setIsSaved] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        onSave();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedValue]);

    useEffect(() => {
        if (value !== debouncedValue) {
            setIsSaved(false);
            setIsSaving(true);
        } else if (isSaving) {
            setIsSaving(false);
            setIsSaved(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedValue, value]);

    return {
        isSaved,
        isSaving,
    };
};

export default useAutoSave;
